import { html, type Html, View } from 'rune-ts';
import klass from '../SpecificCommerceLaws.module.scss';
import { typo } from '../../../../shared/typography/typo';

export class SCL20240617View extends View {
  override template({ is_mobile }): Html {
    return html`
      <div class="${klass.scl_page} ${typo('14_medium')}">
        <h2 class="${is_mobile ? typo('20_bold') : typo('24_bold')}">特定商取引法</h2>

        <h3 class="${typo('16_bold')}">販売業者</h3>
        <p>販売業者 株式会社マープルコーポレーション / Marpple Corporation</p>

        <h3 class="${typo('16_bold')}">代表者</h3>
        <p>Hyeyun Park</p>

        <h3 class="${typo('16_bold')}">所在地/連絡先</h3>
        <p>〒08589 10F, 75-24, Gasan digital 1-ro, Geumcheon-gu, Seoul, Korea</p>

        <h3 class="${typo('16_bold')}">サイトURL</h3>
        <p><a href="/jp">https://marpple.shop/jp/</a></p>

        <h3 class="${typo('16_bold')}">営業時間</h3>
        <p>平日 10:00 ~ 18:00</p>

        <h3 class="${typo('16_bold')}">CSお問い合わせ</h3>
        <p class="${klass.cs}">
          <span>+81) 050 5840 0207</span>
          <span>+82) 050 5840 0207</span>
          <a href="mailto:cs@marppleshop.com">cs@marppleshop.com</a>
        </p>

        <h3 class="${typo('16_bold')}">商品価格</h3>
        <p>各商品ページで確認します。</p>

        <h3 class="${typo('16_bold')}">送料</h3>
        <p>
          <strong>MarppleShop配送商品</strong><br />
          配送国によって、商品の重量と数量に応じて送料が決まります。送料は最低400円から最大10,000円までかかる場合があります。正確な送料は注文書でご確認いただけます。
        </p>
        <p>
          <strong>クリエイター配送商品</strong><br />
          送料はクリエイターが直接設定した金額によって決まります。各商品の詳細ページで、詳しい送料を確認することができます。
        </p>

        <h3 class="${typo('16_bold')}">配送期間</h3>
        <p>
          <strong>MarppleShop配送商品</strong><br />
          1週間単位で注文をまとめ、翌週に製作・発送するシステムのため、注文後に商品が発送されるまで一定の期間がかかります。注文完了（支払い完了）から発送完了まで、平均して8～10日程度かかる場合があります。<br />
          ただし、悪天候の影響や配送業者および現地物流の状況により、通関や配送が遅れる場合があります。その場合、営業日基準で最大15日かかることがありますので、ご了承ください。
        </p>
        <p>
          <strong>クリエイター配送商品</strong><br />
          商品は詳細ページに案内されたスケジュールに沿って発送されます。詳しい配送スケジュールについては、クリエイターにお問い合わせください。
        </p>

        <h3 class="${typo('16_bold')}">支払い方法</h3>
        <p>PayPal</p>

        <h3 class="${typo('16_bold')}">配送関連ポリシー</h3>
        <p>送商品の場合は販売ページで、送料、期間など別途ご案内いたします。</p>

        <h3 class="${typo('16_bold')}">返品/交換に関する要件及び送料</h3>
        <p>
          <strong>MarppleShop配送商品</strong><br />
          オーダーメイド商品の特性上、お客様のご都合によるキャンセル、返品、交換はできません。ただし、不良品の場合は返品および交換が可能です。ご注文いただいた商品とは異なる商品への交換はできません。
        </p>
        <p>
          <strong>クリエイター配送商品</strong><br />
          商品の詳細ページで、クリエイターが直接記載した交換・返金に関する案内事項をご確認いただけます。「お問い合わせ」機能を通じて、クリエイターにお問い合わせください。
        </p>

        <h3 class="${typo('16_bold')}">購入プロセス</h3>
        <div>
          <img
            src="//s3.marpple.co/files/u_218933/2024/8/original/f5aca367b7b07c5ae444a7a8062fcc2ef631532b1.png"
            alt="購入プロセス"
            class="${klass.step_img}"
          />
        </div>
      </div>
    `;
  }
}
